import React, { useState, useEffect } from 'react';
import telegramIcon from '../pages/telegram.svg';
import vkIcon from '../pages/vk.svg';

export default function UnderButtonNav() {
  const [aboutData, setAboutData] = useState(null);

  useEffect(() => {
    fetch('/api/about')
      .then(res => res.json())
      .then(data => setAboutData(data))
      .catch(err => console.error('Ошибка загрузки about.json:', err));
  }, []);

  return (
    <>
      {/* Десктопная версия (lg и выше) */}
      <div className="hidden lg:block text-left py-8 border-t border-white/5 mt-4 bg-[#1b1b1b] relative">
        <div className="max-w-screen-2xl mx-auto px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-slate-400 text-sm max-w-2xl">
            
            {/* Блок 1: Соцсети */}
            <div>
              <h4 className="text-primary text-xs uppercase tracking-wider font-bold mb-3">Следите за нами</h4>
              <div className="flex flex-col gap-3">
                <a 
                  href="https://t.me/AvtoLiderDonbass" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 group hover:text-primary transition-colors"
                >
                  <img 
                    src={telegramIcon} 
                    alt="Telegram" 
                    className="w-5 h-5 opacity-70 group-hover:opacity-100 transition-opacity"
                  />
                  <span className="text-sm tracking-wide">Telegram</span>
                </a>
                <a 
                  href="https://vk.ru/id1087115728" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-3 group hover:text-primary transition-colors"
                >
                  <img 
                    src={vkIcon} 
                    alt="ВКонтакте" 
                    className="w-5 h-5 opacity-70 group-hover:opacity-100 transition-opacity"
                  />
                  <span className="text-sm tracking-wide">ВКонтакте</span>
                </a>
              </div>
            </div>
            
            {/* Блок 2: Страницы */}
            <div>
              <h4 className="text-primary text-xs uppercase tracking-wider font-bold mb-3">Страницы</h4>
              <ul className="space-y-2">
                <li><a href="/" className="text-sm hover:text-primary transition-colors">Главная</a></li>
                <li><a href="/about" className="text-sm hover:text-primary transition-colors">О нас</a></li>
                <li><a href="https://www.drom.ru/pdd/" target="_blank" rel="noopener noreferrer" className="text-sm hover:text-primary transition-colors">Билеты ПДД</a></li>
                <li><a href="/instructors" className="text-sm hover:text-primary transition-colors">Инструкторы</a></li>
                <li><a href="/courses" className="text-sm hover:text-primary transition-colors">Курсы</a></li>
              </ul>
            </div>
            
            {/* Блок 3: Адреса (только адреса, без телефонов и названий) */}
            <div>
              <h4 className="text-primary text-xs uppercase tracking-wider font-bold mb-3">Где нас найти?</h4>
              {aboutData?.addresses && aboutData.addresses.length > 0 ? (
                <ul className="space-y-2">
                  {aboutData.addresses.map((addr) => (
                    <li key={addr.id} className="leading-relaxed">
                      <div className="text-sm text-slate-400">{addr.address}</div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-xs text-slate-500">Загрузка адресов...</p>
              )}
            </div>
          </div>
          
          {/* Теги в правом нижнем углу */}
          <div className="absolute bottom-6 right-8">
            <div className="flex flex-wrap justify-end gap-3 text-[8px] text-slate-500 tracking-wider">
              <span className="hover:text-primary transition-colors cursor-default">#АвтоЛидер</span>
              <span className="hover:text-primary transition-colors cursor-default">#АвтошколаЛуганск</span>
              <span className="hover:text-primary transition-colors cursor-default">#Автолидер181</span>
              <span className="hover:text-primary transition-colors cursor-default">#ПраваЛуганск</span>
            </div>
          </div>
        </div>
      </div>

      {/* Мобильная версия (до lg) — отображается */}
      <div className="lg:hidden text-center py-6 border-t border-white/5 mt-4 bg-[#1b1b1b]">
        <div className="max-w-screen-2xl mx-auto px-6">
          
          {/* Соцсети в строку */}
          <div className="flex justify-center gap-8 mb-6">
            <a 
              href="https://t.me/AvtoLiderDonbass" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-slate-400 hover:text-primary transition-colors"
            >
              <img src={telegramIcon} alt="Telegram" className="w-5 h-5" />
              <span className="text-xs">Telegram</span>
            </a>
            <a 
              href="https://vk.ru/id1087115728" 
              target="_blank" 
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-slate-400 hover:text-primary transition-colors"
            >
              <img src={vkIcon} alt="ВКонтакте" className="w-5 h-5" />
              <span className="text-xs">ВКонтакте</span>
            </a>
          </div>
          
          {/* Страницы в строку */}
          <div className="flex flex-wrap justify-center gap-4 mb-6 text-xs text-slate-400">
            <a href="/" className="hover:text-primary transition-colors">Главная</a>
            <a href="/about" className="hover:text-primary transition-colors">О нас</a>
            <a href="https://www.drom.ru/pdd/" target="_blank" rel="noopener noreferrer" className="hover:text-primary transition-colors">Билеты ПДД</a>
            <a href="/instructors" className="hover:text-primary transition-colors">Инструкторы</a>
            <a href="/courses" className="hover:text-primary transition-colors">Курсы</a>
          </div>
          
          {/* Адреса */}
          <div className="mb-6">
            <h4 className="text-primary text-[10px] uppercase tracking-wider font-bold mb-2">Где нас найти?</h4>
            {aboutData?.addresses && aboutData.addresses.length > 0 ? (
              <div className="space-y-1">
                {aboutData.addresses.map((addr) => (
                  <p key={addr.id} className="text-xs text-slate-400">{addr.address}</p>
                ))}
              </div>
            ) : (
              <p className="text-xs text-slate-500">Загрузка адресов...</p>
            )}
          </div>
          
          {/* Теги */}
          <div className="flex flex-wrap justify-center gap-3 text-[8px] text-slate-500 tracking-wider">
            <span className="hover:text-primary transition-colors cursor-default">#АвтоЛидер</span>
            <span className="hover:text-primary transition-colors cursor-default">#АвтошколаЛуганск</span>
            <span className="hover:text-primary transition-colors cursor-default">#Автолидер181</span>
            <span className="hover:text-primary transition-colors cursor-default">#ПраваЛуганск</span>
          </div>
        </div>
      </div>
    </>
  );
}